
import { defineComponent, PropType } from '@vue/runtime-core'

interface TabItem {
  label: string
  name?: string
  link?: string
}

export default defineComponent({
  name: 'Tab',

  props: {
    list: {
      type: Array as PropType<TabItem[]>,
      required: true
    },
    current: {
      type: Number,
      default: 0
    },
    isPC: {
      type: Boolean,
      default: false
    }
  },

  setup(_, { emit }) {
    const clickTab = (index: number) => emit('click-tab', index)

    return {
      clickTab
    }
  }
})
